import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { IEmbeddedState } from '../IEmbeddedState';

export class NavigationInitiatedEvent implements IEvent {
	public static readonly EventType = 'OrganisationsSearch:NavigationInitiatedEvent';

	public readonly eventType = NavigationInitiatedEvent.EventType;
	public readonly timestamp = new Date();
	public readonly promise: Promise<unknown>;
	public readonly embeddedState: IEmbeddedState;

	public constructor(promise: Promise<unknown>, embeddedState: IEmbeddedState) {
		this.promise = promise;
		this.embeddedState = embeddedState;
	}

	public static is(event: IEvent): event is NavigationInitiatedEvent {
		return event.eventType === NavigationInitiatedEvent.EventType;
	}
}
